var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueBoltIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 140,
    viewBox: "0 0 141 140",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 70,
    r: 70,
    fill: "#FEFEFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1572 32.1486C72.669 29.9259 76.1447 30.996 76.1447 33.6841V59.1887C76.1447 60.6942 77.3635 61.9156 78.869 61.9188L96.4491 61.9565C98.6385 61.9612 99.932 64.4119 98.7005 66.2222L68.7647 110.227C67.2528 112.449 63.7773 111.379 63.7773 108.691V83.1857C63.7773 81.6802 62.5585 80.4588 61.053 80.4556L43.478 80.4178C41.2886 80.4131 39.9951 77.9626 41.2264 76.1523L71.1572 32.1486Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBoltIcon);
export default __webpack_public_path__ + "static/media/blue-bolt-icon.4919dacc39a3e365e3ae14a82a6c340b.svg";
export { ForwardRef as ReactComponent };